import {
  Box,
  Button,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
  CircularProgress,
} from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import SendIcon from '@mui/icons-material/Send';
import LinkIcon from '@mui/icons-material/Link';
import { useState } from 'react';
import { useChat } from './hooks/useChat';

export default function DevssoftChatCore() {
  const [input, setInput] = useState('');
  const {
    messages,
    loading,
    linkedApps,
    retailLinked,
    myStores,
    activeStoreId,
    selectActiveStore,
    sendMessage,
  } = useChat();

  const handleSend = async () => {
    const text = input;
    setInput('');
    await sendMessage(text);
  };

  return (
    <Box sx={{ maxWidth: 960, mx: 'auto', p: { xs: 1, md: 2 } }}>
      <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
          <SmartToyIcon color="primary" />
          <Typography variant="h6" fontWeight={700}>
            DevsSoft Chat
          </Typography>
          <Chip size="small" label="Solo consultas" color="info" variant="outlined" />
          <Chip size="small" icon={<LinkIcon />} label={`${linkedApps.length} app(s) vinculada(s)`} />
          {linkedApps.map((app) => (
            <Chip key={app.app_key} size="small" label={app.label} color="primary" variant="outlined" />
          ))}
        </Stack>

        {retailLinked && (
          <FormControl size="small" sx={{ mt: 2, minWidth: 220 }}>
            <InputLabel>Tienda activa (Retail)</InputLabel>
            <Select
              label="Tienda activa (Retail)"
              value={activeStoreId || ''}
              onChange={(e) => {
                const store = myStores.find((s) => s.store_id === e.target.value);
                if (store) selectActiveStore(store);
              }}
            >
              {myStores.map((s) => (
                <MenuItem key={s.store_id} value={s.store_id}>
                  {s.store_name || s.store_id}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Paper>

      <Paper
        variant="outlined"
        sx={{
          p: 2,
          mb: 2,
          minHeight: 420,
          maxHeight: 520,
          overflowY: 'auto',
          bgcolor: 'grey.50',
        }}
      >
        <Stack spacing={1.5}>
          {messages.map((m) => (
            <Box
              key={m.id}
              sx={{
                alignSelf: m.role === 'user' ? 'flex-end' : 'flex-start',
                maxWidth: '85%',
              }}
            >
              <Paper
                elevation={0}
                sx={{
                  p: 1.5,
                  bgcolor: m.role === 'user' ? 'primary.main' : 'background.paper',
                  color: m.role === 'user' ? 'primary.contrastText' : 'text.primary',
                }}
              >
                <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                  {m.content}
                </Typography>
                {m.sources?.length > 0 && (
                  <Typography variant="caption" color="text.secondary" display="block" mt={0.5}>
                    Fuentes: {m.sources.join(', ')}
                  </Typography>
                )}
              </Paper>
            </Box>
          ))}
          {loading && (
            <Stack direction="row" spacing={1} alignItems="center">
              <CircularProgress size={16} />
              <Typography variant="caption">Consultando datos empresariales...</Typography>
            </Stack>
          )}
        </Stack>
      </Paper>

      <Stack direction="row" spacing={1}>
        <TextField
          fullWidth
          size="small"
          placeholder="Ej: ¿Cuánto vendí hoy? · ¿Cómo va mi inventario?"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSend();
            }
          }}
          disabled={loading}
        />
        <Button
          variant="contained"
          endIcon={<SendIcon />}
          onClick={handleSend}
          disabled={loading || !input.trim()}
        >
          Enviar
        </Button>
      </Stack>
    </Box>
  );
}
